export default [
    {
        title: '工作台',
        icon: 'HomeIcon',
        tagVariant: 'light-warning',
        route: 'dash',
    },
]  